import { navigate } from 'gatsby';
import React from 'react';
import Calendar from 'react-calendar';

import '@css/event-calendar.css';
import 'react-calendar/dist/Calendar.css';

const EventsCalendar = ({ events }) => {
  const currentDate = new Date();
  const currentYear = currentDate.getFullYear();

  const filteredEvents = events.filter(event => {
    const eventDate = new Date(event.ACFevent.date);
    return (
      /*eventDate.getMonth() === currentMonth && */
      eventDate.getFullYear() === currentYear
    );
  });

  const tileClassName = ({ date, view }) => {
    if (
      view === 'month' &&
      filteredEvents.some(
        event =>
          new Date(event.ACFevent.date).toDateString() === date.toDateString()
      )
    ) {
      return 'eventDay';
    }
  };
  const handleDayClick = date => {
    const eventForDate = filteredEvents.find(
      event =>
        new Date(event.ACFevent.date).toDateString() === date.toDateString()
    );

    if (eventForDate) {
      navigate(eventForDate.uri);
    }
  };

  return <Calendar tileClassName={tileClassName} onClickDay={handleDayClick} />;
};

export default EventsCalendar;
